import BetsItem from './BetsItem';

export default BetsItem;
